import React, { useEffect, useState } from "react";
import { read } from "Helpers/LocalStorage";
import { push } from "Helpers/History";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { projectMenuItems } from "Constants/projectMenuItems";
import { SHOW_PROJECTS } from "Stores/actionTypes";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import HistoryState from "./HistoryState";

export default function ProjectOptions({ projectList }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const dispatch = useDispatch();
  let defaultMenuList = [...projectMenuItems];
  let StypeU = read("StypeU");
  const { selectedProject, onClickShowProject, rtlLayout } = useSelector(
    (state) => ({
      selectedProject: state.project.selectedProject,
      onClickShowProject: state.project.onClickShowProject,
      rtlLayout: state.settings.rtlLayout,
    })
  );

  const [newMenu, setNewMenu] = useState(null);
  const [expanded, setExpanded] = useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    if (selectedProject !== "undefined") {
      let _menu = defaultMenuList.filter((item) =>
        item.userAccess.includes(StypeU)
      );
      _menu.map((item) => {
        if (item.menu_title === "construction") {
          const status = !!read("constructCutList") || !!read("constructGlass");
          item.authorize = status;
          item.active = status;
          return null;
        }
        if (item.menu_title === "contract") {
          const status = !!read("contractRules");
          item.authorize = status;
          item.active = status;
          return null;
        }
      });
      const tabBar = _menu.map((item) => {
        if (
          ((!selectedProject || selectedProject === "undefined") &&
            (item.menu_title === "design" ||
              item.menu_title === "invoices" ||
              item.menu_title === "contract" ||
              item.menu_title === "construction" ||
              item.menu_title === "profit")) ||
          !item.authorize
        ) {
          return item;
        } else if (
          item.menu_title === "design" &&
          read("isLockProject") &&
          read("StypeU") == "2"
        ) {
          return item;
        } else {
          return item;
        }
      });
      setNewMenu(tabBar);
    }
  }, [selectedProject]);

  function ProjectMenu({ icon, title, link, action, className }) {
    const handleClick = () => {
      if (action !== "") {
        if (action === "projectShow") {
          dispatch({
            type: SHOW_PROJECTS,
            value: true,
          });
        }
      } else {
        push(link);
      }
    };
    return (
      <div className={`project-options ${className}`} onClick={handleClick}>
        <ReactSVG src={icon} />
        <Translator id={title} />
      </div>
    );
  }

  function ProjectInfo() {
    return (
      <div className="project-info">
        <p>
          <span>{t("projectName")}</span>
          <strong>{selectedProject.Name}</strong>
        </p>
        <p>
          <span>{t("customerName")}</span>
          <strong>{selectedProject.NameCustomer}</strong>
        </p>
        <p>
          <span>{t("date")}</span>
          <span>{selectedProject.DateRegister}</span>
        </p>
        <p>
          <span>{t("state")}</span>
          <span>{selectedProject.NameState}</span>
        </p>
        <p>
          <span>{t("placeLocation")}</span>
          <span>{selectedProject.NameCity}</span>
        </p>
        <p>
          <span>{t("address")}</span>
          <span>
            {selectedProject.Address === ""
              ? "ثبت نشده"
              : selectedProject.Address}
          </span>
        </p>
      </div>
    );
  }

  return (
    <>
      {selectedProject && selectedProject !== "undefined" && newMenu && !onClickShowProject && (
        <>
          <MuiPaper
            className={`project-info-box ${
              direction === "rtl" ? "text-right" : "text-left"
            }`}
          >
            <div className="selected-project-menu">
              {projectList !== 2 && (
                <div className={`list-button rtl-${rtlLayout}`}>
                  {newMenu
                    .filter((item) => item.active !== false)
                    .filter((item) => item.action !== "")
                    .map((item) => {
                      return (
                        <ProjectMenu
                          key={`${Date.now()}-${item.menu_title}`}
                          icon={item.menu_icon}
                          title={item.menu_title}
                          link={item.path}
                          className={`${item.class} wider`}
                          action={item.action}
                        />
                      );
                    })}
                </div>
              )}
              <div className="action-buttons">
                {newMenu
                  .filter((item) => item.active !== false)
                  .filter((item) => item.action === "")
                  .map((item) => {
                    return (
                      <ProjectMenu
                        key={`${Date.now()}-${item.menu_title}`}
                        icon={item.menu_icon}
                        title={item.menu_title}
                        link={item.path}
                        className={item.class}
                        action={item.action}
                      />
                    );
                  })}
              </div>
            </div>
          </MuiPaper>

          <MuiPaper
            className={`project-info-box no-back-color ${
              direction === "rtl" ? "text-right" : "text-left"
            }`}
          >
            <div className="details">
              <div className="inner-box">
                <ProjectInfo />
                <>
                  {selectedProject.HistoryState.length > 0 && (
                    <Accordion
                      className="project-info-accordion"
                      expanded={expanded === "statusHistory"}
                      onChange={handleChange("statusHistory")}
                    >
                      <AccordionSummary>
                        <p className="text-nowrap">
                          {t("statusHistory")}
                          <Icons.CaretUpFill
                            size={16}
                            className={`caret-project me-2 ${
                              expanded === "statusHistory"
                                ? "caret-normal"
                                : "caret-L"
                            }`}
                          />
                        </p>
                      </AccordionSummary>
                      <AccordionDetails className="m-0 p-0 p-2">
                        <HistoryState data={selectedProject.HistoryState} />
                      </AccordionDetails>
                    </Accordion>
                  )}
                </>
              </div>
            </div>
          </MuiPaper>
        </>
      )}
    </>
  );
}
